










import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class Chart extends Vue {
  @Prop({ required: false }) width!: number;
  @Prop({ required: false }) height!: number;
  @Prop({ required: true }) type!: string;
  @Prop({ required: true }) options!: object;
  @Prop({ required: true }) series!: object[];
}
